import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'stock-results',
    templateUrl: './stock-results.component.html'
})

export class StockResultsComponent implements OnInit {
    // Receive Element templateUrl (Ref)
    public element: any;

    public marginElement: any;

    @Input() public resultsDetails: any;
    
    constructor(Element: ElementRef) {}

    ngOnInit() {
    }

    getPercent(actual, gain, loss, variation) {
        if (variation == 'normal' || !actual)
            return 0

        const value = variation == 'high' ? gain : loss;
        const result = ((actual*100)/value)/2
        return result <= 50 ? result : 50;


    }
}